module.exports = __webpack_public_path__ + "img/green-bg.fb1e339d.png";